import { render, staticRenderFns } from "./FreezingScreening.vue?vue&type=template&id=4882e076&"
import script from "./FreezingScreening.vue?vue&type=script&lang=js&"
export * from "./FreezingScreening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports